import { toastError } from 'components/common/Toaster';

export const logError = (error: Error | unknown): Promise<void> => {
    if (error instanceof Error && error.name !== 'AbortError') {
        toastError(error.message);
    }

    return Promise.resolve();
};